import React from 'react';
import { Box, Avatar } from '@mui/material';
import recivedInvitationIcon from '@assets/icons/recived-invitation-icon.svg';
import sendInvitationIcon from '@assets/icons/send-invitation-icon.svg';

const IconFormatterInvitation = ({ cell }) => {
  const type = cell.getValue();
  const icon = type === 0 ? recivedInvitationIcon : type === 1 ? sendInvitationIcon : null;
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 20, minWidth: 20 }}
    >
      {icon && (
        <Avatar
          src={icon} alt="" variant="square" sx={{ width: 14, height: 14, bgcolor: 'transparent', objectFit: 'contain' }}
        />
      )}
    </Box>
  );
};
export default IconFormatterInvitation;
//old logic:
/*import React from 'react';
import recivedInvitationIcon from '@assets/icons/recived-invitation-icon.svg';
import sendInvitationIcon from '@assets/icons/send-invitation-icon.svg';
import { Image } from 'react-bootstrap';

class IconFormatterInvitation extends React.Component {
	render() {
		const type = this.props.value;
		let icon = null;
		if (type === 0) {
			icon = recivedInvitationIcon;
		} else if (type === 1) icon = sendInvitationIcon;
		return (
			<div className='row no-padding'>
				{icon !== null && <Image src={icon} alt='' className='SmartTable-icon-image' />}
			</div>
		);
	}
}
export default IconFormatterInvitation;*/
